function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.999,
    height: 8,
    viewBox: "0 0 7.999 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1387",
    d: "M10.291 17.04a.571.571 0 0 1 .809 0l3.023 3.025 3.024-3.025a.572.572 0 0 1 .809.809l-3.428 3.428a.571.571 0 0 1-.809 0l-3.428-3.428a.571.571 0 0 1 0-.809z",
    transform: "rotate(-90 2.339 15.784)",
    style: {
      fill: "#3c2f87",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1388",
    d: "M17.446 10.125a.571.571 0 0 1 .571.571v5.713a.571.571 0 0 1-1.143 0V10.7a.571.571 0 0 1 .572-.575z",
    transform: "rotate(-90 5.66 15.786)",
    style: {
      fill: "#3c2f87",
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightShort);
export default __webpack_public_path__ + "static/media/arrow-right-short.a67b0032080a9179a6eb690df7c86438.svg";
export { ForwardRef as ReactComponent };